"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaDisplayType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.MediaDisplayType = {
    Banner: 'banner',
    BannerCarousel: 'banner-carousel',
    BannerPromo: 'banner-promo',
    Button: 'button',
    CalmHealthClinicalCarousel: 'calm-health-clinical-carousel',
    CalmHealthDailiesGrid: 'calm-health-dailies-grid',
    CalmHealthExtracted: 'calm-health-extracted',
    CalmHealthGoalsRowCards: 'calm-health-goals-row-cards',
    CalmHealthSnappyQuickNav: 'calm-health-snappy-quick-nav',
    Carousel: 'carousel',
    CarouselLandscape: 'carousel-landscape',
    Grid: 'grid',
    GridLandscape: 'grid-landscape',
    GridNav: 'grid-nav',
    Link: 'link',
    MoodTriage: 'mood-triage',
    Paragraph: 'paragraph',
    QuickNav: 'quick-nav',
    RoundedCarousel: 'rounded-carousel',
    Row: 'row',
    RowCard: 'row-card',
    SingleRowQuickNav: 'single-row-quick-nav',
    SnappyQuickNav: 'snappy-quick-nav',
    Story: 'story',
    Tout: 'tout',
};
//# sourceMappingURL=media-display-type.js.map